import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { Quill } from 'seagull/patches/PatchedQuill';
import styles from './TemplateVariableBlot.module.scss';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Embed = Quill.import('blots/embed');
class TemplateVariableBlot extends Embed {
    static create(value) {
        var _value_label;
        if (!((_value_label = value.label) === null || _value_label === void 0 ? void 0 : _value_label.trim())) {
            throw new Error('TemplateVariableBlot: label must be non-empty');
        }
        const node = super.create();
        node.setAttribute('data-label', value.label);
        node.setAttribute('contenteditable', 'false');
        node.textContent = value.label;
        node.setAttribute('aria-label', "Variable: ".concat(value.label));
        if (value.setup) {
            node.classList.add(styles.setup);
        }
        return node;
    }
    static value(node) {
        return {
            label: node.getAttribute('data-label') || ''
        };
    }
    text() {
        const data = TemplateVariableBlot.value(this.domNode);
        return "{{".concat(data.label, "}}");
    }
}
_define_property(TemplateVariableBlot, "blotName", 'template-variable');
_define_property(TemplateVariableBlot, "tagName", 'span');
_define_property(TemplateVariableBlot, "className", styles.templateVariable);
Quill.register('blots/template-variable', TemplateVariableBlot, true);
export default TemplateVariableBlot;
